import { AgentListItem } from "@/types/agent";
import { 
  getElevenLabsAgents, 
  getElevenLabsAgentById 
} from "../elevenLabsAgentService";

/**
 * Get a specific ElevenLabs agent by ID
 */
export const getElevenLabsAgentByIdConverted = async (agentId: string): Promise<AgentListItem | null> => {
  try {
    if (!agentId.startsWith('el_')) return null;
    
    const elevenLabsAgent = await getElevenLabsAgentById(agentId);
    if (elevenLabsAgent) {
      return {
        id: `el_${elevenLabsAgent.agent_id}`,
        name: elevenLabsAgent.name,
        role: "AI Assistant",
        goal: elevenLabsAgent.description || "conversation",
        active: true,
        source: "elevenlabs",
        tags: elevenLabsAgent.tags,
        created_at_unix_secs: elevenLabsAgent.metadata?.created_at_unix_secs,
        access_info: elevenLabsAgent.access_info,
        llm: {
          provider: "elevenlabs",
          model: "conversational-ai",
        },
      };
    }
    
    return null;
  } catch (error) {
    console.error("Error fetching ElevenLabs agent by ID:", error);
    return null;
  }
};

/**
 * Get all ElevenLabs agents converted to AgentListItem format
 */
export const getElevenLabsAgentsConverted = async (): Promise<AgentListItem[]> => {
  try {
    const elevenLabsAgents = await getElevenLabsAgents();
    
    // Convert ElevenLabsAgent to AgentListItem
    const convertedElevenLabsAgents: AgentListItem[] = elevenLabsAgents.map(agent => ({
      id: `el_${agent.agent_id}`,
      name: agent.name,
      role: "AI Assistant",
      goal: agent.description || "conversation",
      active: true,
      source: "elevenlabs" as const,
      tags: agent.tags,
      created_at_unix_secs: agent.metadata?.created_at_unix_secs,
      access_info: agent.access_info,
      llm: {
        provider: "elevenlabs",
        model: "conversational-ai",
      },
    }));
    
    return convertedElevenLabsAgents;
  } catch (error) {
    console.error("Error fetching ElevenLabs agents:", error);
    return [];
  }
};